import { gql } from '@apollo/client';

// Read-only cache fragments: the fields that place a path record in the selection hierarchy.
const AGE_GROUP_SCOPE_SELECTION = `
    ageGroup {
      _id
      assessmentId
    }
`;

export const PLAYER_ASSESSMENT_SELECTION_SCOPE = gql`
  fragment PlayerAssessmentSelectionScope on PlayerAssessment {${AGE_GROUP_SCOPE_SELECTION}}
`;

export const ASSESSMENT_SESSION_SELECTION_SCOPE = gql`
  fragment AssessmentSessionSelectionScope on AssessmentSession {${AGE_GROUP_SCOPE_SELECTION}}
`;

export const AGE_GROUP_SELECTION_SCOPE = gql`
  fragment AgeGroupSelectionScope on AgeGroup {
    assessmentId
  }
`;

export const DRILL_SELECTION_SCOPE = gql`
  fragment DrillSelectionScope on Drill {
    companyId
  }
`;

export const CALIBRATION_ASSIGNMENT_SELECTION_SCOPE = gql`
  fragment CalibrationAssignmentSelectionScope on CalibrationAssignment {
    companyId
  }
`;
